var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{staticClass:"lg:w-full sm:w-w550 h-w585 sm:ml-auto sm:mr-auto",attrs:{"id":"map","center":{lat:37.2756537, lng:-104.6561154},"zoom":4,"map-type-id":"terrain","options":{
            disableDefaultUI: true,
            draggable: false,
            styles: _vm.mapStyles
        }}},_vm._l((_vm.latlngsmarks),function(latlngsmark,index){return _c('GmapMarker',{key:index,ref:"myMarker",refInFor:true,attrs:{"icon":_vm.icon,"position":_vm.google && new _vm.google.maps.LatLng(latlngsmark.lat, latlngsmark.lng)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }